import filter from 'lodash/filter';

import fromSmoochMessage from 'adapters/converters/fromSmoochMessage';
import messageEnums from 'enums/messages';

export default class SmoochMessageGateway {
  constructor(smooch) {
    this.smooch = smooch;
  }

  fetchMessages() {
    const { messages } = this.smooch.getConversation();
    const textMessages = filter(messages, m => m.metadata.subType === messageEnums.SUB_TYPES.TEXT);

    return textMessages.map(m => fromSmoochMessage(m));
  }

  sendMessage(messageText, metadata = {}, type, sentAt) {
    this.smooch.sendMessage({
      metadata,
      text: messageText,
      type,
      received: sentAt / 1000,
      role: 'appUser',
    });
  }

  updateCustomerUrl(metadata, text, type) {
    this.smooch.sendMessage({ metadata, text, type });
  }

  customerIsTyping() {
    this.smooch.startTyping();
  }

  customerStoppedTyping() {
    this.smooch.stopTyping();
  }

  registerCallbacks({ handleTypingEvent, handleMessageSent, handleMessageReceived }) {
    this.smooch.on('typing:start', handleTypingEvent);
    this.smooch.on('typing:stop', handleTypingEvent);

    this.smooch.on('message:sent', message => handleMessageSent(fromSmoochMessage(message)));
    this.smooch.on('message:received', message => handleMessageReceived(fromSmoochMessage(message)));
  }
}
